import { styled, component } from '../../../utils/style';
import { Format, StyleColor } from '../../../utils/styles-constants';

export const StyledSliderContainer = styled()(component.div, 'StyledSliderContainer')`
	padding: 40px;
	background: ${StyleColor.Black};
	height: calc( 100% - 45px - 64px );/* 100% - header.height - footer.height */
	box-sizing: border-box;

	& .slick-slider,
	& .slick-list,
	& .slick-track{
		height:100%;
	}

	@media ${Format.Smartphone} {
		padding: 15px 30px;
	}
`;

export const SvgArrow = styled()(component.svg, 'SvgArrow')`
	opacity: 0.75;
	pointer-events: all;

	&.slick-disabled{
		opacity: 0.25;
	}

	&:not(.slick-disabled):hover {
		opacity: 1;
	}
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Slider/styles.ts